let namespace = 'derWareHouseConfirmRd_';

const initialState = {
    pagination: {
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        showQuickJumper:true,
        pageSizeOptions: [
            "5",
            "10",
            "20",
            "40",
            "100"
        ]
    },
    dataFetchProps: {order:[['id','desc']], attributes: ["id","serial_no", "apply_no","sale_order_no","remarks","out_total_weight", "out_warehouse_time", "partner_order_no", "order_no", "cust_name", "pay_time","product_list","status"],
        include: [
            {
                model: "der_warehouse_out", // 替换为实际的 Model 名称
                as: 'm_derWareHouseOut',
                attributes: ['id', 'warehouse_enterprise_no', 'warehouse_name']
            },   {
                model: "der_warehouse_file", // 替换为实际的 Model 名称
                as: 'm_derWareHouseFile2',
                attributes: ['id', 'local_url', 'status', 'attachment_type', 'bank_url']
            }
        ]
    },
    // 搜索参数
    searchProps: {},
    // 加载状态，默认是true
    loading: false,
    // 数据列表
    dataList: [],
    // 详细信息显示
    orderRepayDetailVisible: false,
    uploadModalVisible: false,
    orderDetailVisible: false,
    // 正在被查看的项（详细）
    watchedItem: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case namespace + "forcedUpdate": {
            return {
                ...state,
                ...action.payload
            }
        };
        default : {
            return state;
        }
    }
}